import { useEffect, useCallback } from 'react';
import { getDelta } from '@atlassian/jira-portfolio-3-common/src/custom-scrollbar';
import { useTimelineRuler, useHorizontalScrolling } from '../../../controllers';

function useScrollingContainerVSync(scrollableEl: HTMLElement | null, paddingSize: number) {
	const [{ viewport }, { nudge }] = useHorizontalScrolling();
	const [{ msToPx }] = useTimelineRuler();

	useEffect(() => {
		const offsetInPx = msToPx(viewport.offset) || 0;
		if (scrollableEl) {
			// eslint-disable-next-line no-param-reassign
			scrollableEl.scrollLeft = paddingSize + offsetInPx;
		}
	}, [scrollableEl, viewport, msToPx, paddingSize]);

	const handleWheel = useCallback(
		(e: WheelEvent) => {
			const { deltaX, deltaY } = getDelta(e);

			if (Math.abs(deltaX) >= Math.abs(deltaY)) {
				nudge(deltaX);
				e.preventDefault();
			}
		},
		[nudge],
	);

	useEffect(() => {
		if (!scrollableEl) {
			return;
		}

		scrollableEl.addEventListener('wheel', handleWheel, false);
		return () => scrollableEl.removeEventListener('wheel', handleWheel, false);
	}, [scrollableEl, handleWheel]);
}

type Props = {
	paddingSize: number;
	scrollableRef: {
		current: HTMLElement | null;
	};
};

/** Sync the scrolling state within all scroll views. */
export default function ViewportVSync({
	scrollableRef: { current: scrollableEl },
	paddingSize,
}: Props) {
	useScrollingContainerVSync(scrollableEl, paddingSize);
	return null;
}
